import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCampaign } from "./CampaignContext";

export default function LoadCampaign() {
  const nav = useNavigate();
  const { campaigns, refreshCampaigns, loadCampaign, deleteCampaign, error } = useCampaign();

  useEffect(() => {
    refreshCampaigns();
  }, []);

  const handleLoad = async (id) => {
    await loadCampaign(id);
    nav("/dashboard");
  };

  const handleDelete = async (id) => {
    const ok = window.confirm(`Delete campaign "${id}"? This cannot be undone.`);
    if (!ok) return;
    await deleteCampaign(id);
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Load Campaign</h2>

      {error ? <div style={{ color: "crimson", marginTop: 8 }}>{error}</div> : null}

      <div style={{ marginTop: 12 }}>
        <button onClick={refreshCampaigns}>Refresh List</button>
      </div>

      <div style={{ marginTop: 12 }}>
        {campaigns.length === 0 ? (
          <div style={{ opacity: 0.8 }}>No saved campaigns found in /campaigns.</div>
        ) : (
          <table style={{ borderCollapse: "collapse", width: "100%", marginTop: 8 }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Settlement</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Campaign</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Survivors</th>
                <th style={{ textAlign: "left", borderBottom: "1px solid #ddd", padding: 8 }}>Updated</th>
                <th style={{ borderBottom: "1px solid #ddd", padding: 8 }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {campaigns.map((c) => (
                <tr key={c.id}>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>{c.settlementName || c.id}</td>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>{c.campaignType || "-"}</td>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>{c.survivorsCount}</td>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee" }}>{c.updatedAt || "-"}</td>
                  <td style={{ padding: 8, borderBottom: "1px solid #eee", textAlign: "center" }}>
                    <button onClick={() => handleLoad(c.id)} style={{ marginRight: 8 }}>Load</button>
                    <button onClick={() => handleDelete(c.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}